<template>
  <div>
    <transition name="partialloader">
      <div v-if="!context" class="pageloader partial">
        <span class="loading-text">{{loadingText}}</span>
      </div>
    </transition>
    <section v-if="context" class="home">
      <div class="section hero" id="recommend">
        <header class="section-header">
          <h2 class="title basic"><span class="icon-pickup"></span>{{ $t("pickup_title_main") }}<span class="title-jp">{{ $t("pickup_title_sub") }}</span></h2>
        </header>
        <hero-home :items="context.heros"></hero-home>
      </div>
      <div class="section scroller" id="pickup-spot">
        <div class="container">
          <header class="section-header">
            <div class="level is-mobile">
              <div class="level-left">
                <div class="level-item">
                  <h2 class="title basic has-text-left" data-v-step="1">
                    <router-link to="/spots/" class="group-row">
                      <span class="icon-spots"></span>{{ $t("spot_title_main") }}<span class="title-jp">{{ $t("spot_title_sub") }}</span>
                    </router-link>
                  </h2>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <router-link class="view-more" to="/spots/">View All</router-link>
                </div>
              </div>
            </div>
          </header>
        </div>
        <scroller
          :items="context.spots"
          base_dir="/spots/"
          shape="square"
          :total="context.spots_count"
        >
        </scroller>
      </div>
      <div class="section scroller" id="pickup-tour">
        <div class="container">
          <header class="section-header">
            <div class="level is-mobile">
              <div class="level-left">
                <div class="level-item">
                  <h2 class="title basic has-text-left" data-v-step="2">
                    <router-link to="/tours/" class="group-row">
                      <span class="icon-tours"></span>{{ $t("tour_title_main") }}<span class="title-jp">{{ $t("tour_title_sub") }}</span>
                    </router-link>
                  </h2>
                </div>
              </div>
              <div class="level-right">
                <div class="level-item">
                    <router-link class="view-more" to="/tours/">View All</router-link>
                </div>
              </div>
            </div>
          </header>
        </div>
        <scroller
          :items="context.tours"
          base_dir="/tours/"
          shape="wide"
          :total="context.tours_count"
        >
        </scroller>
      </div>
      <div class="section about">
        <div class="columns is-mobile is-multiline is-gapless">
          <div class="column is-6">
            <header class="header-gradient">
              <div class="container">
                <div class="title-group">
                  <h2 class="title is-inverted has-text-right multiline">
                    <div v-if="context_about">
                      <span v-for="copy in context_about.copy" :key="copy.id" v-html="copy.value.heading_text"></span>
                    </div>
                    <span class="is-text-small">{{context_about.title}}</span>
                  </h2>
                </div>
              </div>
            </header>
            <div class="text-wrapper">
              <P class="summary">
                {{context_about.summary}}
              </P>
              <div class="link">
                <router-link :to="'/' + context_about.meta.slug" class="is-underlined" data-v-step="3">Read More</router-link>
              </div>
            </div>
          </div>
          <div class="column is-6">
            <div class="image-wrapper" :style="'background: url(' + baseUrl + context_about.image.url + '); background-size: cover; background-position: center center; background-repeat: no-repeat;'">
            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'
import HeroHome from '../components/HeroHome.vue'
import Scroller from '../components/horizontalScroller.vue'
import { localeHelper } from '../i18n/index'

export default {
  name: 'Home',
  components: {
    HeroHome,
    Scroller,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      type: 'base.HomePage',
      slug: 'home-' + localeHelper(this.$root.$i18n.locale),
      loadingText: 'Loading',
      guide: {
        steps: [
          {
            target: '.icon-question-circle',
            content: 'guide_button',
            offset: -100,
            duration: 800,
          },
          {
            target: '.bm-burger-button',
            content: 'guide_menu',
            offset: -100,
            duration: 800,
          },
          {
            target: `[data-v-step='1']`,
            content: 'guide_spots',
            offset: -100,
            duration: 800,
            params: {
              placement: 'bottom'
            }
          },
          {
            target: `[data-v-step='2']`,
            content: 'guide_tours',
            offset: -100,
            duration: 800,
            params: {
              placement: 'top'
            }
          },
          {
            target: `[data-v-step='3']`,
            content: 'guide_about',
            offset: -100,
            duration: 800,
            params: {
              placement: 'top'
            }
          },
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'getAllPages',
      'isPagesLoaded',
      'getSingleContext',
    ]),
    context: function() {
      return this.getSingleContext(this.slug)
    },
    context_about: function() {
      return this.getSingleContext('about')
    }
  },
  methods: {
    ...mapActions([
      'fetchPageByPath',
      'fetchPageByType',
      'setGuideSteps',
    ]),
  },
  created() {},
  beforeMount() {
    this.fetchPageByType({ type: this.type, slug: this.slug, lang:this.$root.$i18n.locale })
    this.fetchPageByType({ type: 'base.AboutPage', slug: "about", lang:this.$root.$i18n.locale })
  },
  mounted() {
    this.setGuideSteps({ steps: this.guide.steps })
  }
}
</script>
